<template>
  <q-page class="main-wrapper-page single-page" style="background-color: var(--q-accent)">
    <div class="page-head q-mb-lg">
      <section class="widget-section widget-section--filter full-width flex no-wrap items-center q-mb-lg">
        <q-form ref="form" class="full-width">
          <div class="row no-wrap full-width q-col-gutter-sm q-mb-md">
            <div class="col">
              <q-input
                v-model="filters.apmId"
                label="APM ID"
                outlined
                dense
                clearable
                bg-color="white"
                @update:model-value="filterTable"
                @clear="reloadTable()"
              />
            </div>
            <div class="col">
              <q-input
                v-model="filters.displayName"
                label="Display Name"
                outlined
                dense
                clearable
                bg-color="white"
                @update:model-value="filterTable"
                @clear="reloadTable()"
              />
            </div>
            <div class="col-2">
              <q-select
                v-model="filters.kind"
                label="Kind"
                :options="kinds"
                :loading="kindsLoading"
                outlined
                dense
                clearable
                options-dense
                popup-content-class="alternative-id-popup filter-select-popup"
                emit-value
                map-options
                bg-color="white"
                @update:model-value="filterTable"
                @clear="reloadTable()"
              />
            </div>
            <div class="col">
              <q-checkbox
                v-model="filters.deleted"
                @update:model-value="filterTable"
                label="Show deleted"
                class="full-width"
              />
            </div>
            <div class="col">
              <q-checkbox
                v-model="filters.orderable"
                @update:model-value="filterTable"
                label="Show orderable"
                class="full-width"
              />
            </div>
            <div class="col">
              <q-checkbox
                v-model="filters.isCatalogPart"
                @update:model-value="filterTable"
                label="Is catalog part"
                class="full-width"
              />
            </div>
            <div class="col">
              <q-checkbox
                v-model="filters.parentOnly"
                @update:model-value="filterTable"
                label="Parent only"
                class="full-width"
              />
            </div>
          </div>
        </q-form>
      </section>
    </div>
    <section class="widget-section widget-section--table">
      <infra-services-table
        ref="infraServicesTable"
        class="fixed-table"
        :filters="filters"
        @editService="onEditService"
      />
    </section>
  </q-page>

  <q-dialog v-model="showEditPopup" class="single-service-page" persistent>
    <q-card style="min-width: 480px; border-radius: 0px">
      <q-toolbar class="shadow-2 q-py-sm q-px-md">
        <q-toolbar-title class="text-weight-bold">
          <strong>Edit Infra service</strong>
        </q-toolbar-title>
        <q-btn icon="close" style="min-width: 20px" round flat class="btn--no-hover" @click="closeEditPopup"></q-btn>
      </q-toolbar>
      <q-card-section class="q-mx-md q-px-none q-pb-none" style="border-top: 2px solid var(--q-primary)">
        <div class="row no-wrap full-width q-col-gutter-sm q-mb-md">
          <div class="col">
            <q-checkbox v-model="currentService.orderable" label="Orderable"></q-checkbox>
          </div>
          <div class="col">
            <q-checkbox v-model="currentService.is_catalog_part" label="Is Catalog Part"></q-checkbox>
          </div>
        </div>
        <div class="row no-wrap full-width q-col-gutter-sm q-mb-md">
          <div class="col">
            <q-select
              v-model="currentService.kind"
              label="Kind"
              :options="kinds"
              :loading="kindsLoading"
              outlined
              dense
              options-dense
              popup-content-class="alternative-id-popup filter-select-popup"
              emit-value
              map-options
              bg-color="white"
            />
          </div>
        </div>
      </q-card-section>
      <q-card-actions class="q-px-md q-pt-lg q-pb-lg">
        <q-btn
          style="border-radius: 10px; text-transform: capitalize"
          color="primary"
          text-color="text-color"
          :loading="editLoading"
          :disabled="editLoading"
          @click="updateInfraService"
          >Submit</q-btn
        >
        <q-btn
          style="border-radius: 10px; text-transform: capitalize"
          class="btn--no-hover"
          flat
          @click="closeEditPopup"
          >Close</q-btn
        >
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>
import apollo from '@/library/http/apollo';
import gql from 'graphql-tag';
import InfraServicesTable from './components/InfraServicesTable.vue';
import { getEnums } from '@/pages/infraService/api';

export default {
  name: 'InfraServicesPage',
  components: {
    InfraServicesTable,
  },
  data() {
    return {
      filters: {
        apmId: undefined,
        displayName: undefined,
        orderable: false,
        isCatalogPart: false,
        parentOnly: false,
        deleted: false,
        kind: undefined,
      },
      loading: false,
      timeout: undefined,
      showEditPopup: false,
      currentService: undefined,
      editLoading: false,
      kinds: [],
      kindsLoading: false,
    };
  },
  methods: {
    async updateInfraService() {
      this.editLoading = true;
      const updateData = {
        infraServiceId: this.currentService.id,
        orderable: this.currentService.orderable,
        isCatalogPart: this.currentService.is_catalog_part,
        kind: this.currentService.kind || null,
      };
      await apollo.apolloClient
        .mutate({
          mutation: gql`
            mutation updateInfraService($data: FrontendInfraserviceInput!) {
              updateInfraService(data: $data)
            }
          `,
          variables: {
            data: updateData,
          },
        })
        .then(async () => {
          this.$notify('positive', 'Success', `Infraservice was updated successfully.`);
        })
        .catch((error) => {
          this.$notify('negative', 'Error', error.message);
        })
        .finally(async () => {
          this.closeEditPopup();
          this.editLoading = false;
          this.reloadTable();
        });
    },
    async loadKinds() {
      this.kindsLoading = true;
      try {
        const kinds = await getEnums('ERegistrationKind');
        this.kinds = kinds.map((i) => ({ value: i.value, label: i.value }));
      } catch (error) {
        this.$notify('negative', 'Error', error.message);
      } finally {
        this.kindsLoading = false;
      }
    },
    closeEditPopup() {
      this.showEditPopup = false;
      this.currentService = undefined;
    },
    onEditService(service) {
      this.showEditPopup = true;
      this.currentService = JSON.parse(JSON.stringify(service));
    },
    resetFilters() {
      Object.keys(this.filters).forEach((key) => {
        this.filters[key] = undefined;
        this.filters.orderable = false;
        this.filters.isCatalogPart = false;
        this.filters.parentOnly = false;
        this.filters.deleted = false;
      });
      this.reloadTable();
    },
    filterTable() {
      this.$refs.form.validate().then((valid) => {
        if (valid) {
          this.loading = true;
          if (this.timeout) clearTimeout(this.timeout);
          this.timeout = setTimeout(async () => {
            this.reloadTable();
          }, 1500);
        }
      });
    },
    reloadTable() {
      this.$refs.infraServicesTable?.reload();
    },
  },
  mounted() {
    this.loadKinds();

    const query = this.$route.query;

    Object.keys(this.filters).forEach((key) => {
      this.filters[key] = query[key] || undefined;
      if (key === 'deleted' || key === 'orderable' || key === 'isCatalogPart' || key === 'parentOnly') {
        this.filters[key] = query[key] === 'true';
      }
    });

    this.reloadTable();
  },
};
</script>

<style lang="scss" scoped>
.widget-section {
  padding: 16px 16px 16px 5px;
  margin-bottom: 0;
}
.widget-section--btn {
  padding: 16px;
  min-width: 140px;
}
.long-desc {
  max-width: 300px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.showBanner {
  .fixed-table {
    height: calc(100vh - 300px);
  }
}
.fixed-table {
  height: calc(100vh - 240px);
}
.page-head {
  display: flex;
}
</style>
